import { FormRcController, useInjectedHTML } from 'stimulus-library';

export default class extends FormRcController {

  submit(event) {
    useInjectedHTML(this, this.el, 'afterbegin', `<input type="hidden" name="remote-submitted" value="true">`);
    super.submit(event);
  }

}